export enum EMessageType {
  text = 'text',
  video = 'video',
  audio = 'audio',
  error = 'error',
  image = 'image',
}

export enum WorkspaceRoles {
  OWNER = 'OWNER',
  EDITOR = 'CAN_EDIT',
  VIEWER = 'CAN_VIEW',
}

export enum HttpMethod {
  GET = 'get',
}

export enum OrganizationRoles {
  OWNER = 'OWNER',
  EDITOR = 'EDITOR',
  ADMIN = 'ADMIN',
}

export enum EProjectStatus {
  DRAFT = 'DRAFT',
  READY = 'READY',
  WAITING_APPROVAL = 'WAITING_APPROVAL',
  REQUEST_APPROVED = 'REQUEST_APPROVED',
  PUBLISHED = 'PUBLISHED',
  COMPLETED = 'COMPLETED',
}

export enum EPanelIntegration {
  NONE = 'NONE',
  TESTING_TIME = 'TESTING_TIME',
}

export enum EStatusCode {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  INVALID_CREDENTIALS = 401,
  FORBIDDEN = 403,
  EMAIL_TAKEN = 422,
  EMAIL_NOT_FOUND = 407,
  OLD_PASSWORD_NOT_MATCH = 408,
  USER_HAS_NO_ORGANIZATIONS = 409,
  INVALID_ROLE = 410,
  NOT_A_MEMBER = 411,
  WORKSPACE_NOT_FOUND = 412,
  ALREDY_ORGANIZATION_MEMBER = 413,
  ALREDY_WORKSPACE_MEMBER = 414,
  NOT_ORGANIZATION_MEMBER = 415,
  NOT_CORRECT_ORGANIZATION = 416,
  NO_ANOTHER_OWNER = 417,
  PROJECT_NOT_READY = 421,
  PROJECT_NOT_APPROVED = 419,
  PROJECT_ALREADY_PUBLISHED = 420,
  INVALID_WORKSPACE_ROLE = 423,
  INVALID_ORGANIZATION_ROLE = 424,
  PROJECT_NOT_PUBLISHED = 425,
  TEST_CONVERSATION_NOT_FOUND = 426,
  ONE_OWNER_ONLY = 427,
  PROJECT_NAME_EXISTS = 428,
  NOT_WORKSPACE_MEMBER = 429,
  CANT_DELETE_PUBLISHED = 430,
  PROJECT_NOT_FOUND = 431,
  CANT_DELETE_WORKSPACE = 432,
  PROJECT_RESPONDENT_EXCEEDED = 433,
  METADATA_REQUIRED = 434,
  INVALID_LANGUAGE = 435,
  NOT_SUBSCRIBED = 436,
  FILE_EMPTY = 437,
  ALREADY_VERIFIED = 438,
  LABELS_MUST_BE_UNIQUE = 439,
  INVALID_PANEL = 440,
  ORGANIZATION_INVITE_ACCEPTED = 441,
  PROJECT_IS_COMPLETED = 442,
  INVALID_2FA_CODE = 446,
  INVALID_BACKUP_CODE = 447,
  INVALID_2FA_SETUP = 448,
  INVALID_PASSWORD = 449,
  USER_NOT_FOUND = 450,
  THEME_NAME_EXISTS = 451,
}

export enum ECompanyThemeName {
  DEFAULT = 'default',
  EMPATHY = 'empathyiq',
}

export enum ECategoryMode {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}

export enum ECreateThemeModalType {
  CREATE = 'create',
  EDIT = 'edit',
}

export enum EProjectDesignSection {
  INSTRUCTIONS = 'Instructions',
  CONTEXT = 'Context',
  DISCUSSION_GUIDE = 'Discussion Guide',
  SCREENING = 'Screening',
  MAX_RESPONDENTS = 'Max Participants',
}

export enum ScreeningRulesTypes {
  QUALIFY = 'qualify',
  IRRELEVANT = 'irrelevant',
  DISQUALIFY = 'disqualify',
}

export enum ScreeningQuestionType {
  MULTI_SELECT = 'multiSelect',
  SINGLE_SELECT = 'singleSelect',
  NUMERIC = 'numericInput',
  MAX_RESPONDENTS = 'Max Participants',
}

export enum EFilterType {
  TEXT = 'text',
  NUMERIC = 'numeric',
  // NUMBER_RANGE is only for handling missmatch while prepopulating existing filters data
  NUMBER_RANGE = 'numberRange',
  DATE = 'date',
}

export enum EDateTypes {
  RANGE = 'Range',
  BEFORE = 'Before',
  AFTER = 'After',
}

export enum EFilterSelectionType {
  NUMBER_RANGE = 'numberRange',
  DATE = 'date',
  TEXT = 'text',
}

export enum NavigationTabs {
  OVERVIEW = 'overview_tab',
  QUESTIONS = 'questions_tab',
  TRANSCRIPTS = 'transcripts_tab',
  AISEARCH = 'ai_search_tab',
  REPORTS = 'reports_tab',
}

export enum ECookieKey {
  TOKEN = 'token',
  FALLBACK_WORKSPACE = 'fallback_workspace',
  MAIN_ORGANIZATION = 'main_organization',
  REMEMBER_ME = 'remember_me',
}

export enum CategoryDisplayType {
  TALLY = 'tally',
  PERCENTAGE = 'percentage',
}

export enum CategorySortType {
  ASC = 'ascending',
  DESC = 'descending',
  DEFAULT = 'default',
}

export enum EScreeningRulesTypes {
  QUALIFY = 'Qualify',
  IRRELEVANT = 'Irrelevant',
  DISQUALIFY = 'Disqualify',
}

export enum EScreeningQuestionType {
  MULTI_SELECT = 'Multi-select',
  SINGLE_SELECT = 'Single-select',
  NUMERIC = 'Numeric',
}

export enum TranscriptsView {
  COMPLETED = 'completed',
  INCOMPLETE = 'incomplete',
}

export enum QuestionsTab {
  INSIGHTS = 'insights',
  ANSWERS = 'answers',
}

export enum TwoFactorSetupStep {
  INITIAL = 'initial',
  QR_CODE = 'qrcode',
  BACKUP_CODES = 'backupCodes',
}

export enum ConversationView {
  CONVERSATION_OVERVIEW = 'conversation_overview',
  CONVERSATION_DETAILS = 'conversation_details',
  SINGLE_CONVERSATION = 'single_conversation',
  FULL_ANSWERS_TRANSCRIPT = 'full_answers_transcript',
}

export enum ConversationState {
  DONE = 'done',
  IDLE = 'idle',
  LOADING = 'loading',
}

export enum WorkspaceType {
  PRIVATE = 'priv',
  SHARED = 'shared',
}

export enum ConversationNavigationType {
  NEXT = 'next',
  PREV = 'prev',
}
export enum GroupContentType {
  QUESTIONS = 'questions',
  GROUPS = 'groups',
  EMPTY = 'empty',
}

export enum QuestionGroupLimits {
  MAX_QUESTIONS = 40,
  MAX_GROUPS = 20,
}
